import { FC } from 'react';
import { Box, GridItem, GridItemProps } from '@chakra-ui/react';
import { getColorValue } from '@shinetools/sunshine';

import { SIDEBAR_GRID_AREA } from '../../constants';

const PreviewSidebar: FC<GridItemProps> = ({ children, ...props }) => (
  <GridItem {...props} gridArea={SIDEBAR_GRID_AREA}>
    <Box
      boxShadow={`inset 1px 0px 0px ${getColorValue('grey.200')}`}
      height="100%"
      overflowY="auto"
      zIndex="1"
    >
      {children}
    </Box>
  </GridItem>
);

export default PreviewSidebar;
